import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <i className="ri-shield-check-line text-xl text-primary-500"></i>
              <span className="text-lg font-semibold text-foreground-950">应用安全指南</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              致力于普及应用安全知识，帮助用户识别和防范破解软件带来的安全风险，推荐安全可靠的正版替代方案。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-3">内容分类</h4>
            <ul className="flex flex-col gap-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-3">快速链接</h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/category/alternatives" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                  替代方案推荐
                </Link>
              </li>
              <li>
                <Link to="/category/security-risks" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                  安全风险警示
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-3">免责声明</h4>
            <p className="text-xs text-foreground-500 leading-relaxed">
              本站内容仅供安全科普和教育目的，不鼓励、不支持任何形式的软件盗版行为。我们强烈建议所有用户从官方渠道下载和使用正版软件。如发现本站内容有误，欢迎联系我们进行更正。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 应用安全指南. 本站内容仅供安全科普参考，不构成任何法律建议。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}